import supportModule from '../../support.module';

export default supportModule.component('supportAvatar', {
    styleUrls: require('./supportAvatar.component.css'),
    template: require('./supportAvatar.component.html'),
    controller: controller,
    bindings: {
        type: '<',
        username: '<',
        width: '<',
        height: '<'
    }
});

function controller(__env) {
    var vm = this;

    vm.$onInit = () => {
        vm.showAvatar = false;
        vm.width = vm.width ? vm.width : 50;
        vm.height = vm.height ? vm.height : 50;
    };

    vm.getSrc = () => {
        if (vm.username) {
            return `${__env.cloudApiUrl}/api/v2/users/${
                vm.username
            }/avatar?width=${vm.width}&height=${vm.height}`;
        }
    };

    vm.styleDimensions = () => {
        return {
            width: `${vm.width}px`,
            height: `${vm.height}px`
        };
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-avatar/supportAvatar.component.js